__turbopack_context__.v({
  "buttonRows": "Capabilities-module__0mx2Ka__buttonRows",
  "buttonRowsWrapper": "Capabilities-module__0mx2Ka__buttonRowsWrapper",
  "cardImgContainer": "Capabilities-module__0mx2Ka__cardImgContainer",
  "cardTextContent": "Capabilities-module__0mx2Ka__cardTextContent",
  "content": "Capabilities-module__0mx2Ka__content",
  "fadeIn": "Capabilities-module__0mx2Ka__fadeIn",
  "featuresContainer": "Capabilities-module__0mx2Ka__featuresContainer",
  "root": "Capabilities-module__0mx2Ka__root",
  "styledCapability": "Capabilities-module__0mx2Ka__styledCapability",
  "text": "Capabilities-module__0mx2Ka__text",
});
